import React from 'react';
import NoSSR from 'react-no-ssr';
import Chip from 'Chip';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import AreaStaticChip from '@Container/common/client/components/areaStaticChip';
import Recommend from './recommend';
import PicNewsAndVideo from './picNewsAndVideo';
import NewsList from './newsList';

class RightContent extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { chipObj, recommend, picNews, newsList, video, asideAd1, asideAd2, asideAd3, asideAd4, asideAd5 },
        } = this.props;

        return (
            <div className={styles.rightContent}>
                <NoSSR>
                    <Chip
                        id={chipObj.asideAd1}
                        type="static"
                        title="侧边广告1"
                        groupName="正文右侧"
                        translate="handleAreaAd"
                        content={asideAd1}>
                        <AreaStaticChip styleName={asideAd1 ? styles.chip_box1 : styles.chip_ebox1} />
                    </Chip>
                </NoSSR>
                <Chip
                    id={chipObj.recommend}
                    type="recommend"
                    title="频道推荐"
                    groupName="正文右侧"
                    translate="handleRecommend"
                    content={recommend}>
                    <Recommend />
                </Chip>
                <NoSSR>
                    <Chip
                        id={chipObj.asideAd2}
                        type="static"
                        title="侧边广告2"
                        groupName="正文右侧"
                        translate="handleAreaAd"
                        content={asideAd2}>
                        <AreaStaticChip styleName={asideAd2 ? styles.chip_box2 : styles.chip_ebox2} />
                    </Chip>
                </NoSSR>
                <NoSSR>
                    <Chip
                        id={chipObj.asideAd3}
                        type="static"
                        title="侧边广告3"
                        groupName="正文右侧"
                        translate="handleAreaAd"
                        content={asideAd3}>
                        <AreaStaticChip styleName={asideAd3 ? styles.chip_box3 : styles.chip_ebox3} />
                    </Chip>
                </NoSSR>
                <Chip
                    id={chipObj.picNews}
                    type="recommend"
                    title="图片新闻"
                    groupName="正文右侧"
                    translate="handlePicAndVideo"
                    content={picNews}>
                    <PicNewsAndVideo type="pic" />
                </Chip>
                <NoSSR>
                    <Chip
                        id={chipObj.asideAd4}
                        type="static"
                        title="侧边广告4"
                        groupName="正文右侧"
                        translate="handleAreaAd"
                        content={asideAd4}>
                        <AreaStaticChip styleName={asideAd4 ? styles.chip_box4 : styles.chip_ebox4} />
                    </Chip>
                </NoSSR>
                <Chip
                    id={chipObj.newsList}
                    type="recommend"
                    title="新闻列表"
                    groupName="正文右侧"
                    translate="handleNewsList"
                    content={newsList}>
                    <NewsList />
                </Chip>
                <Chip
                    id={chipObj.video}
                    type="recommend"
                    title="视频"
                    groupName="正文右侧"
                    translate="handlePicAndVideo"
                    content={video}>
                    <PicNewsAndVideo type="video" />
                </Chip>
                <NoSSR>
                    <Chip
                        id={chipObj.asideAd5}
                        type="static"
                        title="侧边广告5"
                        groupName="正文右侧"
                        translate="handleAreaAd"
                        content={asideAd5}>
                        <AreaStaticChip styleName={asideAd5 ? styles.chip_box5 : styles.chip_ebox5} />
                    </Chip>
                </NoSSR>
            </div>
        );
    }
}

export default errorBoundary(RightContent);
